import { create } from "zustand";
import { LocalStorage, LocalStorageKeys } from "../utils/local-storage.utils";
import type { IUser } from "../types/models/user.models.types";
import { AccountType } from "../constants/account-types.constants";
import type { IBrands } from "../brands/hooks/http/colab/workspace/get-workspace.hook";

interface IUserStore {
  token: string | null;
  user: IUser | null;
  brands: IBrands[] | null;
  setBrands: (brands: IBrands[]) => void;
  setUser: (user: IUser) => void;
  login: (
    token: string,
    user: IUser,
    brands: IBrands[] | null
  ) => Promise<void>;
  logout: () => Promise<void>;
}

export const useUserStore = create<IUserStore>((set) => {
  const match = window.location.pathname.match(
    /ephemeral\/brand-dash\/([^/]+)/
  );
  const campaignId = match ? match[1] : "";

  return {
    token: LocalStorage.getInstance().get(
      window.location.pathname.includes("/ephemeral")
        ? (`@dash/ephemeral/brand-dash/${campaignId}` as LocalStorageKeys)
        : LocalStorageKeys.token
    ),
    user: null,
    brands: null,
    setBrands: (brands: IBrands[]) => set(() => ({ brands })),
    setUser: async (user: IUser) => {
      set({ user });
    },

    login: async (token: string, user: IUser, brands: IBrands[] | null) => {
      if (user.accountType === AccountType.EPHEMERAL) {
        LocalStorage.getInstance().set(
          `@dash/ephemeral/brand-dash/${campaignId}` as LocalStorageKeys,
          token
        );
        set({ token, user });
        return;
      }
      LocalStorage.getInstance().set(LocalStorageKeys.token, token);
      set({ token, user, brands });
    },
    logout: async () => {
      LocalStorage.getInstance().clear();
      set({ token: null, user: null, brands: null });
    },
  };
});
